<template>
<div class="p-4 d-flex justify-content-start flex-grow-1">
    <input 
        type="text"
        class="form-control fuente"
        style="text-transform: uppercase;"
        placeholder="buscar privada(o) de libertad por nombre completo o número de documento de identidad"
        id="complemento"
    >
        <button 
            type="button"
            class="btn btn-primary"
        >
        <i class="fa fa-search"></i>
        </button>
        <button 
            type="button"
            class="btn btn-info"
        >
        <i class="fa fa-eraser"></i>
        </button>
</div>  
</template>

<script>
export default {

}
</script>

<style>

</style>